import styled from 'styled-components';

export const BadgeItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 14px;
  width: 14px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.unreadRed};
  position: absolute;
  top: 0;
  right: -5px;
`